export default class LoyaltyCodeFormModel {
  public loyaltyCode: string = '';
}
